module.exports = __webpack_public_path__ + "static/media/challenge_icon_active.0bb1d107.svg";